import React, { useEffect, useState } from "react";
import { Select, Form } from "antd";
import { store } from '@root/store';

export interface TitleProps {
	id: number,
	name: string
}

export interface TitleSelectProps {
	label?: string | boolean,
	name?: string,
	styles?: React.CSSProperties,
	showAll?: boolean,
	placeholder?: string,
	rules?: any,
	onSelect?: (value: number) => void;
}

const { Option } = Select;
const TitleSelect: React.FC<TitleSelectProps> = (props) => {
	const { label, name, styles, showAll, placeholder, rules, onSelect } = props;
	const [subjectList, setList] = useState<TitleProps []>([]);

	useEffect(() => {
		setList(store.getState().directionaries.titleData)
	}, [])

	const onSelectHandle = (value: number) => {
		onSelect && onSelect(value)
	}
	
	return (
		<Form.Item 
			label={label} 
			name={name} 
			style={{...styles}}
			rules={rules}
		>
			<Select placeholder={placeholder} onSelect={onSelectHandle}>
				{ showAll && <Option value="all">全部</Option> }
				{
					subjectList.map((subject, index) => {
						return (
							<Option key={index} value={subject.id}>{subject.name}</Option>
						)
					})
				}
			</Select>
		</Form.Item>
  )
}

TitleSelect.defaultProps = {
	label: '职称',
	name: 'subject',
	showAll: false,
	placeholder: '请选择所在职称'
}

export default TitleSelect;